const wsStore: { ws: WebSocket | undefined } = { ws: undefined };

export const webSocketGetter = () => wsStore.ws;

export const webSocketSetter = (ws: WebSocket | undefined) => {
  if (wsStore.ws) {
    wsStore.ws?.close();
  }
  wsStore.ws = ws;
};
